import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';

export function getCustomerList(params) {
    return axios.post(`${BaseApiUrl}/ProductSKU/GetCustomerList`, params);
}

//送货单上传模板
export const DownloadDeliveryInfoExcelTemplate=`${BaseUrl}/template/receive/收货单导入模板.xls`;


//送货单导入URL
export const ImportDeliveryInfo=`${BaseApiUrl}/ReceiveManage/ImportDeliveryInfo`;